import {Component}             from '@angular/core';
import {TableWrapperComponent} from '../../../../../comps/table/table-wrapper/table-wrapper.component';
import {MenuDragPanelBase}     from '../menu-drag-panel-base';

@Component({
			   selector   : 'app-menu-drag-panel-log',
			   imports    : [
				   TableWrapperComponent
			   ],
			   templateUrl: './menu-drag-panel-log.component.html',
			   styleUrl   : './menu-drag-panel-log.component.css'
		   })
export class MenuDragPanelLogComponent extends MenuDragPanelBase {

}
